module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-07-46a63e1dc664ad1ed3126a899a241885.jpg";